import { Button, Card, CardContent, Dialog, DialogContent, Grid, Icon, IconButton, Link, Stack, Tooltip, Typography } from '@mui/material'
import Input from 'common/components/form/Input'
import IssuesAction from 'common/actions/IssuesAction'
import { withDevLots } from 'dev/DevLotsUtils'
import { REFRESH } from 'common/components/action/ActionConstant'
import { ALIGN, CardTable, SORT } from 'common/components/datatable/Table'
import { STATUS_TICKETS_ID_AND_LABEL, STATUS_TICKETS_LABEL } from 'common/constants/Constants'
import useActions from 'common/hooks/useActions'
import useFetch from 'common/hooks/useFetch'
import useTitles from 'common/hooks/useTitles'
import ApplicationConf from 'conf/ApplicationConf'
import PropTypes from 'prop-types'
import React, { useMemo, useState } from 'react'
import { DialogAddTicket, DialogAddNoteTicket, DialogOKTicket, DialogRemoveTicket } from './DialogTicket'
import RecetteStatsCards from './RecetteStatsCards'
import UndoIcon from '@mui/icons-material/Undo'
import CheckCircleIcon from '@mui/icons-material/CheckCircle'
import WatchLaterIcon from '@mui/icons-material/WatchLater'
import CancelIcon from '@mui/icons-material/Cancel'
import EmojiPeopleIcon from '@mui/icons-material/EmojiPeople'
import { getFullDateMini } from 'common/utils/DateUtil'
import { shallowEqual, useSelector } from 'react-redux'
import { toast } from 'react-toastify'
import { ExportAction } from 'common/utils/ExportUtils'
import useLocalStorage from 'common/hooks/useLocalStorage'
import { CardTitle } from 'common/components/card/Card'
import { darkBlue } from 'app/theme'
import Select from 'common/components/form/Select'
import ReactECharts from 'echarts-for-react'
import { orderBy, sortBy, uniqBy } from 'lodash'
import { BasicDialogAction, BasicDialogTitle } from 'common/components/modal/DialogComponents'
import { STATUS } from 'common/constants/storeConstants'
import Checkbox from 'common/components/form/Checkbox'
import { removePipes, truncateString } from 'common/utils/StringUtil'
import InfoIcon from '@mui/icons-material/Info'

const ROUGE = '#B10202'
const ORANGE = '#ff9900ff'
const JAUNE = '#fffb00ff'
const VERT = '#34A853'
const BLANC = '#e7e7e7ff'

const FIRST = 1
const SECOND = 2
const THIRD = 3
const FOURTH = 4
const FIFTH = 5

const VERSION = {
    RECETTE: 'En recette',
    ATTENTE: 'En attente',
}

const getStatusAndColorTicket = (ticket) => {
    if (ticket.status === STATUS_TICKETS_LABEL.REOUVERT) {
        return ['NOK', ROUGE, FOURTH]
    } else if (
        ticket.status === STATUS_TICKETS_LABEL.EN_VALIDATION_INTERNE &&
        ticket.testeur !== undefined && ticket.testeur !== ''
    ) {
        return ['A tester', JAUNE, THIRD]
    } else if (ticket.status === STATUS_TICKETS_LABEL.EN_VALIDATION_INTERNE) {
        return ['A tester', ORANGE, SECOND]
    } else if (ticket.status === STATUS_TICKETS_LABEL.ATTENTE_MISE_EN_PRODUCTION) {
        return ['OK', VERT, FIFTH]
    }
    return [ticket.status, BLANC, FIRST]
}

const FilterRecette = ({
    tickets = [],
    filters = {},
    setFilters = () => {},
    showTicketOK = true,
    setShowTicketOK = () => {},
    showTicketInternValidation = true,
    setShowTicketInternValidation = () => {},
    showProject = true,
}) => {
    const { searchValue = [], testeur = [], lot = [], project = [], reporter = [], handler = [] } = filters

    const resetFilter = () => {
        setFilters({})
        setShowTicketOK(true)
    }

    return (
        <Card>
            <CardTitle title='Filtre' color={darkBlue} />
            <CardContent>
                <Grid container spacing={1} alignItems='center'>
                    <Grid size={4}>
                        <Input
                            label='Rechercher'
                            value={searchValue}
                            onChange={v => setFilters({ ...filters, searchValue: v })}
                        />
                    </Grid>
                    <Grid size={4}>
                        <Select
                            multiple
                            label='Testeur'
                            value={testeur}
                            items={sortBy(uniqBy(tickets.filter(t => t.testeur), 'testeur').map(t => ({ value: t.testeur, label: t.testeur })), 'value')}
                            onChange={v => setFilters({ ...filters, testeur: v })}
                            undefinedValue
                        />
                    </Grid>
                    <Grid size={4}>
                        <Select
                            multiple
                            label='Lot'
                            value={lot}
                            items={sortBy(uniqBy(tickets, 'lot').map(t => ({ value: t.lot, label: t.lot })), 'value')}
                            onChange={v => setFilters({ ...filters, lot: v })}
                            undefinedValue
                        />
                    </Grid>
                    {showProject && (
                        <Grid size={4}>
                            <Select
                                multiple
                                label='Projet'
                                value={project}
                                items={sortBy(uniqBy(tickets, 'project').map(t => ({ value: t.project, label: t.project })), 'value')}
                                onChange={v => setFilters({ ...filters, project: v })}
                                undefinedValue
                            />
                        </Grid>
                    )}
                    <Grid size={4}>
                        <Select
                            multiple
                            label='Rapporteur'
                            value={reporter}
                            items={sortBy(uniqBy(tickets, 'reporter').map(t => ({ value: t.reporter, label: t.reporter })), 'value')}
                            onChange={v => setFilters({ ...filters, reporter: v })}
                            undefinedValue
                        />
                    </Grid>
                    <Grid size={4}>
                        <Select
                            multiple
                            label='Assigné à'
                            value={handler}
                            items={sortBy(uniqBy(tickets, 'handler').map(t => ({ value: t.handler, label: t.handler })), 'value')}
                            onChange={v => setFilters({ ...filters, handler: v })}
                            undefinedValue
                        />
                    </Grid>
                    <Grid container size={12} spacing={1} justifyContent={'space-between'}>
                        <Checkbox
                            label='Afficher les tickets OK'
                            checked={showTicketOK}
                            onToggle={ () => setShowTicketOK(!showTicketOK) }
                        />
                        <Checkbox
                            label='Afficher les tickets en validation interne qui ne sont pas dans la recette'
                            checked={showTicketInternValidation}
                            onToggle={ () => setShowTicketInternValidation(!showTicketInternValidation) }
                        />
                        <Button variant='outlined' onClick={() => resetFilter()}>Réinitialiser</Button>
                    </Grid>
                </Grid>
            </CardContent>
        </Card>)
}

FilterRecette.propTypes = {
    tickets: PropTypes.arrayOf(PropTypes.shape({})),
    filters: PropTypes.object,
    setFilters: PropTypes.func,
    showTicketOK: PropTypes.bool,
    setShowTicketOK: PropTypes.func,
    showTicketInternValidation: PropTypes.bool,
    setShowTicketInternValidation: PropTypes.func,
    showProject: PropTypes.bool,
}

const PieTickets = ({
    tickets = [],
}) => {
    const nbTicketsOK = tickets.filter(row => row.version === VERSION.RECETTE && row.status === STATUS_TICKETS_LABEL.ATTENTE_MISE_EN_PRODUCTION).length
    const nbTicketsNOK = tickets.filter(row => row.version === VERSION.RECETTE && row.status === STATUS_TICKETS_LABEL.REOUVERT).length
    const nbTicketsToTest = tickets.filter(row => row.version === VERSION.RECETTE && row.status === STATUS_TICKETS_LABEL.EN_VALIDATION_INTERNE).length
    const otherTickets = tickets.length - nbTicketsNOK - nbTicketsOK - nbTicketsToTest

    const options = {
        tooltip: {
            trigger: 'item',
            formatter: '{a} <br/>{b}: {c} ({d}%)',
        },
        toolbox: {
            show: true,
            feature: {
                saveAsImage: {
                    show: true,
                    title: 'Télécharger l\'image',
                    name: 'Recette',
                    backgroundColor: 'white',
                    pixelRatio: 2,
                },
            },
            right: '10px',
            top: 40,
        },
        title: {
            text: 'Répartition des status des différents tickets\n de la recette',
            left: 'center',
            top: 2,
            bottom: 2,
            textStyle: {
                fontSize: 10,
                fontWeight: 'bold',
            },
        },
        series: [
            {
                name: 'Recette',
                type: 'pie',
                radius: ['40%', '65%'],
                selectedMode: 'single',
                top: 6,
                label: {
                    show: true,
                    position: 'inside',
                    formatter (params) {
                        if (!params.value || params.value === 0) {
                            return ''
                        }
                        return `${params.name}\n${params.value}`
                    },
                    fontSize: 10,
                    color: '#000000',
                },
                labelLine: {
                    show: false,
                },
                data: [
                    { value: nbTicketsToTest, name: 'A tester', itemStyle: { color: JAUNE } },
                    { value: nbTicketsNOK, name: 'KO', itemStyle: { color: ROUGE } },
                    { value: nbTicketsOK, name: 'OK', itemStyle: { color: VERT } },
                    { value: otherTickets, name: 'Autres', itemStyle: { color: BLANC } },
                ],
            },
        ],
    }

    return (
        <Card>
            <ReactECharts
                option={options}
                notMerge={true}
                lazyUpdate={true}
                style={{ height: '300px' }}
            />
        </Card>
    )
}

PieTickets.propTypes = {
    tickets: PropTypes.arrayOf(PropTypes.shape({})),
}

const formattingUpdateTicket = ticket => ({
    id: ticket.id,
    version: ticket.version,
    status: ticket.status,
    testeur: ticket.testeur,
    product: removePipes(ticket.product),
    changeLog: ticket.changeLog,
})

const formattingExportData = (tickets) => {
    const headers = [
        { value: 'Testeur' },
        { value: 'Statut' },
        { value: 'Identifiant' },
        { value: 'Lot' },
        { value: 'Projet' },
        { value: 'Produit' },
        { value: 'Balises' },
        { value: 'Résumé' },
        { value: 'Rapporteur' },
        { value: 'Affecté à' },
        { value: 'Dernière modification' },
        { value: 'ChangeLog' },
    ]

    const rows = tickets.map(ticket => {
        const row = [
            { value: ticket.testeur ?? '' },
            { value: ticket.status ?? '' },
            { value: String(ticket.id) },
            { value: ticket.lot ?? '' },
            { value: ticket.project ?? '' },
            { value: removePipes(ticket.product) ?? '' },
            { value: ticket.balises ?? '' },
            { value: ticket.summary ?? '' },
            { value: ticket.reporter ?? '' },
            { value: ticket.handler ?? '' },
            { value: getFullDateMini(ticket.lastUpdated * 1000) ?? '' },
            { value: ticket.changeLog ?? '' },
        ]

        return row
    })

    return [headers,
        ...rows,
    ]
}

const CellTesteur = ({
    row = {},
    reload = () => {},
    validateTooltip = false,
}) => {
    const [openTooltip, setOpenTooltip] = useState(false)

    const login = useSelector(store => store.app.user?.email, shallowEqual)

    function formatTesteur(email) {
        const localPart = email.split('@')[0]
        const parts = localPart.split('.')
        return parts[0].charAt(0) + parts[1]
    }

    // Ticket affecté à l'utilisateur courant et non "OK" -> on propose la désaffectation (et pas l'affectation).
    const canUnassign = !!login && row.testeur === formatTesteur(login) && row.status !== STATUS_TICKETS_LABEL.ATTENTE_MISE_EN_PRODUCTION

    const saveTesteur = (ticket) => {
        setOpenTooltip(false)
        const updateIssue = formattingUpdateTicket(ticket)
        updateIssue.testeur = formatTesteur(login)
        IssuesAction.updateIssues([updateIssue]).then(() => reload())
    }

    const removeTesteur = (ticket) => {
        setOpenTooltip(false)
        const updateIssue = formattingUpdateTicket(ticket)
        updateIssue.testeur = ''
        IssuesAction.updateIssues([updateIssue]).then(() => reload())
    }

    return (
        <Grid
            container
            spacing={1}
            alignItems='center'
            justifyContent='space-between'
            sx={{ flexWrap: 'nowrap' }}
        >
            <Grid size='grow'>
                <Typography noWrap>{row.testeur}</Typography>
            </Grid>
            <Grid size='auto'>
                {!canUnassign && !validateTooltip && (
                    <Tooltip title={'M\'affecter en testeur'} enterDelay={300} enterNextDelay={300}>
                        <IconButton sx={{ color: '#000' }} size='actionTable' onClick={() => saveTesteur(row)}>
                            <EmojiPeopleIcon fontSize='inherit'/>
                        </IconButton>
                    </Tooltip>
                )}
                {!canUnassign && validateTooltip && (
                    <Tooltip
                        placement='top-start'
                        arrow
                        slotProps={{
                            popper: { disablePortal: true },
                        }}
                        open={openTooltip}
                        disableFocusListener
                        disableHoverListener
                        disableTouchListener
                        title={
                            <Grid style={{ padding: 5 }}>
                                <span style={{ fontSize: '14px' }}>Êtes-vous sûr de vouloir vous affecter le ticket ?</span>
                                <Grid container justifyContent='flex-end' className='padding-top-1'>
                                    <Button variant='outlined' color='primary' className='white margin-right-1' onClick={() => setOpenTooltip(false)}>Non</Button>
                                    <Button onClick={() => saveTesteur(row)} variant='contained' >Oui</Button>
                                </Grid>
                            </Grid>
                        }
                    >
                        <IconButton sx={{ color: '#000' }} size='actionTable' onClick={() => setOpenTooltip(true)}>
                            <EmojiPeopleIcon fontSize='inherit'/>
                        </IconButton>
                    </Tooltip>
                )}
                {canUnassign && (
                    <Tooltip title={'Me désaffecter'} enterDelay={300} enterNextDelay={300}>
                        <IconButton sx={{ color: '#000' }} size='actionTable' onClick={() => removeTesteur(row)}>
                            <span style={{ position: 'relative', display: 'inline-flex', alignItems: 'center', justifyContent: 'center', fontSize: 'inherit' }}>
                                <EmojiPeopleIcon fontSize='inherit'/>
                                <span style={{ position: 'absolute', width: '100%', height: '2px', backgroundColor: 'currentColor', transform: 'rotate(-45deg)' }}/>
                            </span>
                        </IconButton>
                    </Tooltip>
                )}
            </Grid>
        </Grid>
    )
}

CellTesteur.propTypes = {
    row: PropTypes.object,
    reload: PropTypes.func,
    validateTooltip: PropTypes.bool,
}

const CardTableRecette = ({
    title = '',
    tickets = [],
    headers = [],
    reload = () => {},
    setMessage= () => {},
    setAddTicket = () => {},
    setRemoveTicket = () => {},
    setOpenOKDialog = () => {},
    setTicketOK = () => {},
    setOpenKODialog = () => {},
    setTicketKO = () => {},
}) => {
    const actions = [{
        icon: 'add',
        tooltip: 'Ajouter un ticket',
        onClick: () => setAddTicket(1),
    }, {
        icon: 'download',
        tooltip: 'Exporter',
        displayed: tickets.length != 0,
        onClick: () => {
            const exportData = formattingExportData(tickets)
            ExportAction.exportData(exportData, 'Recette')
        },
    }]

    const putTicketOnHold = (t) => {
        const updateIssue = formattingUpdateTicket(t)
        updateIssue.version = VERSION.ATTENTE
        IssuesAction.updateIssues([updateIssue]).then(() => reload())
    }

    const undoTicket = (t) => {
        const updateIssue = formattingUpdateTicket(t)
        updateIssue.status = STATUS_TICKETS_LABEL.EN_VALIDATION_INTERNE
        IssuesAction.updateIssues([updateIssue]).then(() => reload())

        const content = 'Le ticket est de retour en phase de test'
        IssuesAction.addNote(t.id, content).then(() => reload())
    }

    const { user } = useSelector(store => ({ user: store.app.user }), shallowEqual)

    const formattingTableRecette = (list) => list.map(row => {
        const event = row.status === STATUS_TICKETS_LABEL.EN_VALIDATION_INTERNE ?
            (
                <>
                    <Tooltip title={'Valider le ticket'} enterDelay={300} enterNextDelay={300}>
                        <IconButton
                            sx={{ color: '#00AA00' }}
                            size='actionTable'
                            onClick={() => {
                                if (![undefined, ''].includes(row.testeur)) {
                                    setTicketOK(row)
                                    setOpenOKDialog(true)
                                } else {
                                    toast.warn('Il faut que le ticket possède un testeur avant de pouvoir le valider')
                                }
                            }}
                        >
                            <CheckCircleIcon fontSize='inherit'/>
                        </IconButton>
                    </Tooltip>
                    <Tooltip title={'Passer le ticket en attente'} enterDelay={300} enterNextDelay={300}>
                        <IconButton
                            sx={{ color: '#000' }}
                            size='actionTable'
                            onClick={() => {
                                putTicketOnHold(row)
                            }}
                        >
                            <WatchLaterIcon fontSize='inherit'/>
                        </IconButton>
                    </Tooltip>
                    <Tooltip title={'Réouvrir le ticket'} enterDelay={300} enterNextDelay={300}>
                        <IconButton
                            sx={{ color: '#FF0000' }}
                            size='actionTable'
                            onClick={() => {
                                if (![undefined, ''].includes(row.testeur)) {
                                    setMessage(`Testeur : ${row.testeur}, Testé => KO\nCause:`)
                                    setTicketKO(row)
                                    setOpenKODialog(true)
                                } else {
                                    toast.warn('Il faut que le ticket possède un testeur avant de pouvoir le réouvrir')
                                }
                            }}
                        >
                            <CancelIcon fontSize='inherit'/>
                        </IconButton>
                    </Tooltip>
                </>
            ) : (
                <Tooltip title={'Annuler'} enterDelay={300} enterNextDelay={300}>
                    <IconButton
                        sx={{ color: '#000' }}
                        size='actionTable'
                        onClick={() => {
                            undoTicket(row)
                        }}
                    >
                        <UndoIcon fontSize='inherit'/>
                    </IconButton>
                </Tooltip>
            )

        const testeur = (
            <CellTesteur
                row={row}
                reload={() => reload()}
                validateTooltip={![undefined, ''].includes(row.testeur)}
            />
        )

        const id = (
            <Link target='_blank' href={`https://support.aquasys.fr/view.php?id=${row.id}`}>
                {row.id}
            </Link>
        )
        const [statusTicket, color, idStatusTicket] = getStatusAndColorTicket(row)

        const statusTicketWithToolTip = (
            <Tooltip title={row.status}>
                {statusTicket}
            </Tooltip>
        )

        const summaryWithToolTip = (
            <Tooltip title={row.summary}>
                {truncateString(row.summary, 50)}
            </Tooltip>
        )

        const changeLogWithToolTip = row.changeLog ? (
            <Tooltip title={row.changeLog}>
                {truncateString(row.changeLog, 30)}
            </Tooltip>
        ) : row.changeLog

        return {
            id: row.id,
            version: row.version,
            actions: { value: event },
            testeur: { value: testeur, sortValue: row.testeur },
            status: { value: statusTicketWithToolTip, color, sortValue: idStatusTicket },
            idIssue: { value: id, sortValue: row.id },
            summary: { value: summaryWithToolTip, sortValue: row.summary },
            project: { value: row.project },
            lot: { value: row.lot },
            reporter: { value: row.reporter },
            handler: { value: row.handler, rightIcon: row.handler === user.loginMantis ? { icon: 'person', color: darkBlue } : {} },
            lastUpdated: { value: getFullDateMini(row.lastUpdated * 1000), sortValue: parseInt(row.lastUpdated) },
            product: { value: removePipes(row.product) },
            balises: { value: row.balises },
            changeLog: { value: changeLogWithToolTip, sortValue: row.changeLog } }
    })

    const formattedTickets = formattingTableRecette(tickets)

    return (
        <CardTable
            title={title}
            headers={headers}
            rows={orderBy(formattedTickets, d => d.project.value)}
            color='#161832'
            rowsPerPageDefault={25}
            actions={actions}
            defaultSort={{ column: 'status', direction: SORT.ASC }}
            lineActions={[{
                icon: 'clear',
                onClick: (row) => setRemoveTicket(row.id),
                align: ALIGN.RIGHT,
                tooltip: 'Retirer de la recette',
            }]}
        />
    )
}

CardTableRecette.propTypes = {
    title: PropTypes.string,
    tickets: PropTypes.arrayOf(PropTypes.shape({})),
    headers: PropTypes.arrayOf(PropTypes.shape({})),
    reload: PropTypes.func,
    setMessage: PropTypes.func,
    setAddTicket: PropTypes.func,
    setRemoveTicket: PropTypes.func,
    setOpenOKDialog: PropTypes.func,
    setTicketOK: PropTypes.func,
    setOpenKODialog: PropTypes.func,
    setTicketKO: PropTypes.func,
}

const formattingTableHold = list => list.map(row => {
    const summaryWithToolTip = (
        <Tooltip title={row.summary}>
            {truncateString(row.summary, 50)}
        </Tooltip>
    )

    const changeLogWithToolTip = row.changeLog ? (
        <Tooltip title={row.changeLog}>
            {truncateString(row.changeLog, 50)}
        </Tooltip>
    ) : row.changeLog

    return {
        id: row.id,
        version: row.version,
        idIssue: { value: row.id },
        summary: { value: summaryWithToolTip, sortValue: row.summary },
        project: { value: row.project },
        lot: { value: row.lot },
        reporter: { value: row.reporter },
        handler: { value: row.handler },
        lastUpdated: { value: getFullDateMini(row.lastUpdated * 1000) },
        product: { value: removePipes(row.product) },
        balises: { value: row.balises },
        changeLog: { value: changeLogWithToolTip, sortValue: row.changeLog },
    }
},
)

const formattingUpdateTicketOnHold = ticket => ({
    id: ticket.id,
    version: ticket.version,
    product: removePipes(ticket.product?.value),
    changeLog: ticket.changeLog?.value,
})

const CardTableOnHold = ({
    title= '',
    tickets=[],
    headers= [],
    reload= () => {},
    setAddTicket= () => {},
    setRemoveTicket= () => {},
}) => {
    const actions = [{
        icon: 'add',
        tooltip: 'Ajouter un ticket',
        onClick: () => setAddTicket(2),
    }]

    const ticketToTest = (t) => {
        const updateIssue = formattingUpdateTicketOnHold(t)
        updateIssue.version = VERSION.RECETTE
        IssuesAction.updateIssues([updateIssue]).then(() => reload())
    }

    return (
        <CardTable
            title={title}
            headers={headers}
            rows={formattingTableHold(tickets)}
            color='#161832'
            rowsPerPageDefault={25}
            actions={actions}
            lineActions={[{
                icon: 'clear',
                onClick: (row) => setRemoveTicket(row.id),
                align: ALIGN.RIGHT,
                tooltip: 'Retirer de la recette',
            }, {
                icon: 'bug_report',
                onClick: (e) => ticketToTest(e),
                align: ALIGN.LEFT,
                tooltip: 'Ticket à tester',
            }]}
            onClickRow={({ id }) => window.open(`https://support.aquasys.fr/view.php?id=${id}`, '_blank')}
        />
    )
}

CardTableOnHold.propTypes = {
    title: PropTypes.string,
    tickets: PropTypes.arrayOf(PropTypes.shape({})),
    headers: PropTypes.arrayOf(PropTypes.shape({})),
    reload: PropTypes.func,
    setAddTicket: PropTypes.func,
    setRemoveTicket: PropTypes.func,
}

const formattingTableInternValidation = list => list.map(row => {
    const summaryWithToolTip = (
        <Tooltip title={row.summary}>
            {truncateString(row.summary, 50)}
        </Tooltip>
    )

    const changeLogWithToolTip = row.changeLog ? (
        <Tooltip title={row.changeLog}>
            {truncateString(row.changeLog, 50)}
        </Tooltip>
    ) : row.changeLog

    return {
        id: row.id,
        version: row.version,
        idIssue: { value: row.id },
        summary: { value: summaryWithToolTip, sortValue: row.summary },
        project: { value: row.project },
        lot: { value: row.lot },
        reporter: { value: row.reporter },
        handler: { value: row.handler },
        lastUpdated: { value: getFullDateMini(row.lastUpdated * 1000) },
        product: { value: removePipes(row.product) },
        balises: { value: row.balises },
        changeLog: { value: changeLogWithToolTip, sortValue: row.changeLog },
    }
},
)

const CardTableInternValidation = ({
    title= '',
    tickets=[],
    headers= [],
    reload= () => {},
    setOpen= () => {},
}) => {
    const actions = [{
        icon: 'playlist_add',
        tooltip: 'Ajouter tous les tickets dans la recette',
        onClick: () => setOpen(true),
    }]

    const setRemoveTicket = (id) => IssuesAction.updateIssues([{ id, status: STATUS_TICKETS_LABEL.ATTENTE_VALIDATION_INTERNE }]).then(() => reload())

    const ticketToTest = (id) => IssuesAction.updateIssues([{ id, version: VERSION.RECETTE }]).then(() => reload())

    return (
        <>
            <CardTable
                title={title}
                headers={headers}
                rows={formattingTableInternValidation(tickets)}
                color='#161832'
                rowsPerPageDefault={25}
                actions={actions}
                lineActions={[{
                    icon: 'clear',
                    onClick: (row) => setRemoveTicket(row.id),
                    align: ALIGN.RIGHT,
                    tooltip: 'Passer le ticket en attente de validation interne',
                }, {
                    icon: 'bug_report',
                    onClick: (row) => ticketToTest(row.id),
                    align: ALIGN.LEFT,
                    tooltip: 'Ticket à tester',
                }]}
                onClickRow={({ id }) => window.open(`https://support.aquasys.fr/view.php?id=${id}`, '_blank')}
            />
        </>
    )
}

CardTableInternValidation.propTypes = {
    title: PropTypes.string,
    tickets: PropTypes.arrayOf(PropTypes.shape({})),
    headers: PropTypes.arrayOf(PropTypes.shape({})),
    reload: PropTypes.func,
    setOpen: PropTypes.func,
}

const formatIssuesRecette = list => list.map(row => ({
    testeur: row.testeur,
    status: STATUS_TICKETS_ID_AND_LABEL[row.status],
    id: row.id,
    project: row.project,
    product: row.product,
    summary: row.summary,
    balises: Array.isArray(row.balises) ? row.balises.join(', ') : row.balises,
    reporter: row.reporter,
    handler: row.handler,
    lastUpdated: row.last_updated,
    changeLog: row.changeLog,
    version: row.version,
    lot: row.lot,
}))

const headersIssuesRecette = [
    { key: 'actions', value: '' },
    { key: 'testeur', value: 'Testeur', width: '100px' },
    { key: 'status', value: 'Statut' },
    { key: 'idIssue', value: 'Id' },
    { key: 'summary', value: 'Titre' },
    { key: 'project', value: 'Projet' },
    { key: 'lot', value: 'Lot' },
    { key: 'reporter', value: 'Rapporteur' },
    { key: 'handler', value: 'Affecté à' },
    { key: 'lastUpdated', value: 'Dernière\nmodification' },
    { key: 'product', value: 'Produit' },
    { key: 'balises', value: 'Balises' },
    { key: 'changeLog', value: 'Changelog' },
]

const headersIssuesHold = [
    { key: 'idIssue', value: 'Id' },
    { key: 'summary', value: 'Titre' },
    { key: 'project', value: 'Projet' },
    { key: 'lot', value: 'Lot' },
    { key: 'reporter', value: 'Rapporteur' },
    { key: 'handler', value: 'Affecté à' },
    { key: 'lastUpdated', value: 'Dernière\nmodification' },
    { key: 'product', value: 'Produit' },
    { key: 'balises', value: 'Balises' },
    { key: 'changeLog', value: 'Changelog' },
]

const headersIssuesInternValidation = [
    { key: 'idIssue', value: 'Id' },
    { key: 'summary', value: 'Titre' },
    { key: 'project', value: 'Projet' },
    { key: 'lot', value: 'Lot' },
    { key: 'reporter', value: 'Rapporteur' },
    { key: 'handler', value: 'Affecté à' },
    { key: 'lastUpdated', value: 'Dernière\nmodification' },
    { key: 'product', value: 'Produit' },
    { key: 'balises', value: 'Balises' },
    { key: 'changeLog', value: 'Changelog' },
]

const validTicket = (t, reload, product, changeLog, tags) => {
    const updateIssue = {
        ...formattingUpdateTicket(t),
        status: STATUS_TICKETS_LABEL.ATTENTE_MISE_EN_PRODUCTION,
        product,
        changeLog,
        // Set complet des balises du ticket (ajout/retrait). Envoyé uniquement à la validation.
        tags: tags ?? [],
    }
    IssuesAction.updateIssues([updateIssue]).then(() => reload())

    const content = `Testeur : ${t.testeur}, Testé => OK`

    IssuesAction.addNote(t.id, content).then(() => reload())
}

const cancelTicket = (t, reload, message, files) => {
    const updateIssue = {
        ...formattingUpdateTicket(t),
        status: STATUS_TICKETS_LABEL.REOUVERT,
    }
    IssuesAction.updateIssues([updateIssue]).then(() => reload())

    IssuesAction.addNote(t.id, message, files).then(() => reload())
}


const RecetteApp = ({ iaeau = false }) => {
    useTitles(() => [{
        label: iaeau ? 'Recette IAEAU' : 'Recette',
        href: iaeau ? '/recette/iaeau' : '/recette',
    }], [iaeau])

    const [filters, setFilters] = useLocalStorage(iaeau ? 'filterRecetteIaeau' : 'filterRecette', {})
    const [showTicketOK, setShowTicketOK] = useState(true)
    const [showTicketInternValidation, setShowTicketInternValidation] = useState(true)

    const [removeTicket, setRemoveTicket] = useState(0)
    const [addTicket, setAddTicket] = useState(0)

    const [openOKDialog, setOpenOKDialog] = useState(false)
    const [ticketOK, setTicketOK] = useState(undefined)

    const [openKODialog, setOpenKODialog] = useState(false)
    const [ticketKO, setTicketKO] = useState(undefined)
    const [message, setMessage] = useState('')

    const [openStartRecettePopUp, setOpenStartRecettePopUp] = useState(false)
    const [openEndRecettePopUp, setOpenEndRecettePopUp] = useState(false)
    const [version, setVersion] = useState('')

    const [openAddAllInternValidationPopUp, setOpenAddAllInternValidationPopUp] = useState(false)

    const {
        data: mantisTickets = [],
        reload,
        status,
    } = useFetch(iaeau ? ApplicationConf.support.recetteIaeau() : ApplicationConf.support.recette(), {}, { formatResult: formatIssuesRecette })

    const {
        data: mantisTicketsInternValidation = [],
        reload: reloadInternValidation,
        status: statusInternValidation,
    } = useFetch(iaeau ? ApplicationConf.support.internValidationIaeau() : ApplicationConf.support.internValidation(), {}, { formatResult: formatIssuesRecette })

    // Lot affiché (colonne, filtre, export) = lot DEV Aquaparc du ticket (gdl), plus le champ Mantis « Lot ».
    const { data: devLots } = useFetch(ApplicationConf.devLot.all())
    const tickets = useMemo(() => withDevLots(mantisTickets, devLots ?? []), [mantisTickets, devLots])
    const ticketsInternValidation = useMemo(() => withDevLots(mantisTicketsInternValidation, devLots ?? []), [mantisTicketsInternValidation, devLots])

    // Nb de tickets en "Attente validation interne" (statut 60) = à venir pour la prochaine recette.
    const {
        data: attenteValidation = {},
        reload: reloadAttenteValidation,
    } = useFetch(iaeau ? ApplicationConf.support.attenteValidationCountIaeau() : ApplicationConf.support.attenteValidationCount())

    const reloadAll = () => {
        reload()
        reloadInternValidation()
        reloadAttenteValidation()
    }

    useActions(() => [{
        type: REFRESH,
        onClick: reloadAll,
        loading: status === STATUS.LOADING,
    }], [status, statusInternValidation])

    const ticketsInternValidationFormatted = useMemo(() => {
        const { searchValue, lot, project, reporter, handler } = filters
        const searchValueFiltered = searchValue ? ticketsInternValidation.filter(t => {
            const searchField = `${t.id} ${t.project} ${t.product} ${t.summary} ${t.balises} ${t.handler} ${t.reporter} ${t.changeLog}`.toLocaleLowerCase()
            return searchField.includes(searchValue.toLocaleLowerCase())
        }) : ticketsInternValidation
        const lotFiltered = lot?.length ? searchValueFiltered.filter(t => lot.includes(t.lot)) : searchValueFiltered
        const projectFiltered = project?.length ? lotFiltered.filter(t => project.includes(t.project)) : lotFiltered
        const reporterFiltered = reporter?.length ? projectFiltered.filter(t => reporter.includes(t.reporter)) : projectFiltered
        return handler?.length ? reporterFiltered.filter(t => handler.includes(t.handler)) : reporterFiltered
    }, [ticketsInternValidation, filters])

    const ticketsToTest = useMemo(() => {
        const { searchValue, testeur, lot, project, reporter, handler } = filters
        const searchValueFiltered = searchValue ? tickets.filter(t => {
            const searchField = `${t.id} ${t.project} ${t.product} ${t.summary} ${t.balises} ${t.handler} ${t.reporter} ${t.changeLog}`.toLocaleLowerCase()
            return searchField.includes(searchValue.toLocaleLowerCase())
        }) : tickets
        const testeurFiltered = testeur?.length ? searchValueFiltered.filter(t => testeur.includes(t.testeur)) : searchValueFiltered
        const lotFiltered = lot?.length ? testeurFiltered.filter(t => lot.includes(t.lot)) : testeurFiltered
        const projectFiltered = project?.length ? lotFiltered.filter(t => project.includes(t.project)) : lotFiltered
        const reporterFiltered = reporter?.length ? projectFiltered.filter(t => reporter.includes(t.reporter)) : projectFiltered
        const handlerFiltered = handler?.length ? reporterFiltered.filter(t => handler.includes(t.handler)) : reporterFiltered
        const ticketOKFiltered = !showTicketOK ? handlerFiltered.filter(t => t.status !== STATUS_TICKETS_LABEL.ATTENTE_MISE_EN_PRODUCTION) : handlerFiltered

        return ticketOKFiltered.filter(row => row.version === VERSION.RECETTE)
    }, [tickets, filters, showTicketOK])

    const ticketOnHold = useMemo(() => {
        const { searchValue, lot, project, reporter, handler } = filters
        const searchValueFiltered = searchValue ? tickets.filter(t => {
            const searchField = `${t.id} ${t.project} ${t.product} ${t.summary} ${t.balises} ${t.handler} ${t.reporter} ${t.changeLog}`.toLocaleLowerCase()
            return searchField.includes(searchValue.toLocaleLowerCase())
        }) : tickets
        const lotFiltered = lot?.length ? searchValueFiltered.filter(t => lot.includes(t.lot)) : searchValueFiltered
        const projectFiltered = project?.length ? lotFiltered.filter(t => project.includes(t.project)) : lotFiltered
        const reporterFiltered = reporter?.length ? projectFiltered.filter(t => reporter.includes(t.reporter)) : projectFiltered
        const handlerFiltered = handler?.length ? reporterFiltered.filter(t => handler.includes(t.handler)) : reporterFiltered

        return handlerFiltered.filter(row => row.version === VERSION.ATTENTE)
    }, [tickets, filters])

    const addTicketOnRecette = (id) => {
        IssuesAction.updateIssues([{ id: parseInt(id, 10), version: addTicket === 1 ? VERSION.RECETTE : VERSION.ATTENTE }]).then(() => reloadAll())
    }
    const removeTicketOnRecette = (id) => {
        IssuesAction.updateIssues([{ id: parseInt(id, 10), version: '' }]).then(() => reloadAll())
    }

    const titleInternValidation = (
        <Grid container spacing={1} alignItems='center' display='inline-flex'>
            <Typography fontSize={20} fontWeight='bold'>{'Tickets en validation interne'}</Typography>
            <Tooltip title={'Ce tableau contient tous les tickets qui sont en validation interne mais qui ne sont pas dans la recette'}>
                <InfoIcon />
            </Tooltip>
        </Grid>
    )

    const addAllInternValidation = () => {
        const formattedTickets = ticketsInternValidationFormatted.map(t => {
            return {
                id: t.id,
                version: VERSION.RECETTE,
            }
        })
        IssuesAction.updateIssues(formattedTickets).then(() => reloadAll())
    }

    return (
        <>
            <Stack spacing={2}>
                <Grid container spacing={2}>
                    <Grid container size={10} alignItems='flex-start' justifyContent='space-between'>
                        <Grid size={12}>
                            <FilterRecette
                                tickets={tickets}
                                filters={filters}
                                setFilters={setFilters}
                                showTicketOK={showTicketOK}
                                setShowTicketOK={setShowTicketOK}
                                showTicketInternValidation={showTicketInternValidation}
                                setShowTicketInternValidation={setShowTicketInternValidation}
                                showProject={!iaeau}
                            />
                        </Grid>
                        <Grid size={12}>
                            <Stack direction='row' spacing={2} alignItems='center' justifyContent='space-between'>
                                <Button
                                    variant='contained'
                                    color='primary'
                                    onClick={() => setOpenStartRecettePopUp(true)}
                                >
                                    Passer les tickets en attente de validation interne en recette
                                    <Icon fontSize='small'>play_arrow</Icon>
                                </Button>
                                <RecetteStatsCards nbToCome={attenteValidation.count} />
                                <Button
                                    variant='contained'
                                    color='primary'
                                    onClick={() => setOpenEndRecettePopUp(true)}
                                >
                                    Valider tous les tickets OK de la recette
                                    <Icon fontSize='small'>play_arrow</Icon>
                                </Button>
                            </Stack>
                        </Grid>
                    </Grid>
                    <Grid size={2}>
                        <PieTickets tickets={ticketsToTest}/>
                    </Grid>
                </Grid>
                {ticketsInternValidationFormatted.length !== 0 && showTicketInternValidation && (
                    <CardTableInternValidation
                        title={titleInternValidation}
                        headers={headersIssuesInternValidation}
                        tickets={ticketsInternValidationFormatted}
                        reload={reloadAll}
                        setOpen={setOpenAddAllInternValidationPopUp}
                    />
                )}
                <CardTableRecette
                    title={`Tickets ${iaeau ? 'IAEAU ' : ''}en recette`}
                    headers={headersIssuesRecette}
                    tickets={ticketsToTest}
                    reload={reloadAll}
                    setMessage={setMessage}
                    setAddTicket={setAddTicket}
                    setRemoveTicket={setRemoveTicket}
                    setOpenOKDialog={setOpenOKDialog}
                    setTicketOK={setTicketOK}
                    setOpenKODialog={setOpenKODialog}
                    setTicketKO={setTicketKO}
                />

                <CardTableOnHold
                    title={`Tickets ${iaeau ? 'IAEAU ' : ''}en attente`}
                    headers={headersIssuesHold}
                    tickets={ticketOnHold}
                    reload={reloadAll}
                    setAddTicket={setAddTicket}
                    setRemoveTicket={setRemoveTicket}
                />
            </Stack>
            <DialogAddTicket
                open={addTicket !== 0}
                onClose={() => setAddTicket(0)}
                onValidate={addTicketOnRecette}
            />
            <DialogRemoveTicket
                id={removeTicket}
                open={removeTicket !== 0}
                onClose={() => setRemoveTicket(0)}
                onValidate={removeTicketOnRecette}
            />
            {openOKDialog && <DialogOKTicket
                title='Passer le ticket en OK'
                ticketName={`${ticketOK.id} - ${ticketOK.summary}`}
                open={openOKDialog}
                onClose={() => setOpenOKDialog(false)}
                onValidate={(m, p, tags) => {
                    validTicket(ticketOK, reload, p, m, tags)
                    setTicketOK()
                }}
                product={removePipes(ticketOK.product)}
                changeLog={ticketOK.changeLog}
                balises={ticketOK.balises ?? []}
            />}
            {openKODialog && <DialogAddNoteTicket
                title={`Passer le ticket en NOK (${ticketKO.id} - ${ticketKO.summary})`}
                open={openKODialog}
                onClose={() => setOpenKODialog(false)}
                onValidate={(m, f) => {
                    cancelTicket(ticketKO, reload, m, f)
                    setOpenKODialog(false)
                    setTicketKO()
                }}
                message={message}
                multiple
                fileAccept='image/*'
            />}
            <Dialog
                open={openStartRecettePopUp}
                maxWidth='md'
            >
                <BasicDialogTitle onClose={() => setOpenStartRecettePopUp(false)}>
                    Passer les tickets en attente de validation interne en recette
                </BasicDialogTitle>
                <DialogContent>
                    Etes vous sûr de vouloir passer les tickets en Recette ?
                </DialogContent>
                <BasicDialogAction
                    onValidate={() => {
                        setOpenStartRecettePopUp(false)
                        IssuesAction.issuesMEI(iaeau).then(() => reloadAll())
                    }}
                />
            </Dialog>
            <Dialog
                open={openEndRecettePopUp}
                maxWidth='md'
            >
                <BasicDialogTitle onClose={() => setOpenEndRecettePopUp(false)}>
                    Valider tous les tickets OK de la recette
                </BasicDialogTitle>
                <DialogContent>
                    <Input
                        label='Numéro de version'
                        value={version}
                        onChange={setVersion}
                    />
                </DialogContent>
                <BasicDialogAction onValidate={() => {
                    if (version !== '') {
                        setOpenEndRecettePopUp(false)
                        IssuesAction.endRecette(version, iaeau).then(() => reloadAll())
                        setVersion('')
                    } else {
                        toast.error('Veuillez préciser un numéro de version')
                    }
                }}
                />
            </Dialog>
            <Dialog
                open={openAddAllInternValidationPopUp}
                maxWidth='md'
            >
                <BasicDialogTitle onClose={() => setOpenAddAllInternValidationPopUp(false)}>
                    Passer les tickets en validation interne en recette
                </BasicDialogTitle>
                <DialogContent>
                    Êtes vous sur de vouloir passer tous les tickets en validation interne dans la recette ?
                </DialogContent>
                <BasicDialogAction
                    onValidate={() => {
                        setOpenStartRecettePopUp(false)
                        addAllInternValidation()
                    }}
                />
            </Dialog>
        </>
    )
}

RecetteApp.propTypes = {
    iaeau: PropTypes.bool,
}

export default RecetteApp